








































import {Component, Vue, Watch} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';
import Snackbar from '@/modules/common/snackbar/_components/Snackbar.vue';
import LoaderFullscreen from '@/modules/common/loader/_components/LoaderFullscreen.vue';
import Sidebar from '@/components/Sidebar.vue';
import Bottombar from '@/components/Bottombar.vue';
import CatchmentDialog from '@/modules/catchments/_components/CatchmentDialog.vue';
import GeoSearch from '@/components/GeoSearch.vue';
import WelcomeDialog from '@/components/WelcomeDialog.vue';
import InfoDialog from '@/modules/catchments/_components/InfoDialog.vue';
import GeoCatchment from '@/components/GeoCatchment.vue';

@Component({
  components: {
    GeoCatchment,
    InfoDialog, WelcomeDialog, GeoSearch, CatchmentDialog, Bottombar, Sidebar, LoaderFullscreen, Snackbar},
})
export default class MainHome extends Vue {
  @Action('catchments/startQuickCatchment') private startQuickCatchment!: any;
  @Action('catchments/stopQuickCatchment') private stopQuickCatchment!: any;
  @Action('catchments/setWelcomeDialog') private setWelcomeDialog!: any;
  @Action('common/loader/start') private startLoader!: any;
  @Action('common/loader/stop') private stopLoader!: any;

  @Getter('catchments/quickCatchment') private quickCatchment!: any;
  @Getter('auth/user') private user!: any;

  private triggerQuickCatchment() {
    // TODO: close all popups on the map
    if (!this.quickCatchment) {
      this.startQuickCatchment();
    } else {
      this.stopQuickCatchment();
    }
  }

  private mounted() {
    window.addEventListener('keydown', (e: KeyboardEventInit) => {
      if (e.key === 'Escape' && this.quickCatchment) {
        this.stopQuickCatchment();
      }
    });
  }

  private openInfo() {
    this.setWelcomeDialog(true);
  }
}
